// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__2dooA","label":"Slider_label__3ANtr","container":"Slider_container__YeIei","slider":"Slider_slider__3Pn6I","rangeValue":"Slider_rangeValue__2LZnJ"};